<template>
  <form-page-template
      :dirty="dirty"
      @save="doSave">
    <template #toolbar-items>
<!--      <edit-toggle-button-->
<!--          v-if="!isCategory2nd('external')"-->
<!--          component-name="Dictionary">-->
<!--      </edit-toggle-button>-->
      <icon-btn
          v-if="showExport"
          tooltip="CSV エクスポート"
          icon="mdi-cloud-download-outline"
          @click="exportDictionary">
      </icon-btn>
      <icon-btn
          tooltip="CSV からアップデート"
          icon="mdi-cloud-upload-outline"
          @click="openCsvUpdateDialog">
      </icon-btn>
      <v-toolbar-title class="with-divider">
        {{ dictionary.name }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="publish" v-if="isEditable">
        <v-icon class="mr-2">mdi-flag</v-icon>
        {{ `バージョン ${dictionaryIdInfo.version} として確定` }}
      </v-btn>
    </template>

    <template>
      <v-row dense>
        <v-col cols="6" md="2">
          <hds-id-field
              :value="dictionary.id"
              label="ID"
              hide-details/>
        </v-col>
        <v-col cols="12" :md="isCategory2nd('common') ? 6 : 10">
          <v-text-field
              v-if="isEditable"
              v-model="dictionary.name"
              label="辞書名"
              :rules="[v => !!v || '辞書名が必要です']">
          </v-text-field>
          <text-field-like
              v-else
              :value="dictionary.name"
              label="辞書名"
              hide-details>
          </text-field-like>
        </v-col>
        <v-col cols="6" md="4" v-if="isCategory2nd('common')">
          <owner-field
              :value="dictionary.ownerId"
              label="事業者">
          </owner-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
              v-if="isEditable"
              v-model="dictionary.description"
              label="説明"
              messages="複数行入力可"
              rows="1"
              auto-grow>
          </v-textarea>
          <text-field-like
              v-else
              :value="dictionary.description"
              label="説明"
              placeholder="未設定"
              hide-details
              multi-line>
          </text-field-like>
        </v-col>
      </v-row>

      <!-- 辞書トークン -->
      <v-row class="pt-1" v-if="showToken">
        <v-col cols="6" :set="token = issuedToken === undefined ? (dictionary.tokens && dictionary.tokens[0]) : issuedToken">
          <v-text-field
              :label="`${isCategory2nd('common') ? dictionaryTypeNames['common'] : dictionaryTypeNames['external']}トークン`"
              :value="loadingToken ? '' : token"
              :placeholder="loadingToken ? '処理中...' : '未発行'"
              :loading="loadingToken"
              readonly
              outlined
              hide-details
              persistent-placeholder>
            <template #append>
              <icon-btns>
                <icon-btn
                    v-if="isEditable && token"
                    tooltip="失効"
                    tooltip-short-delay
                    icon="mdi-close"
                    icon-color="red"
                    @click="revokeToken">
                </icon-btn>
                <icon-btn
                    v-if="isEditable"
                    :tooltip="token ? '再発行' : '発行'"
                    tooltip-short-delay
                    icon="mdi-refresh"
                    @click="issueToken">
                </icon-btn>
                <icon-btn
                    v-if="token && navigator.clipboard"
                    tooltip="クリップボードにコピー"
                    tooltip-short-delay
                    icon="mdi-clipboard-outline"
                    class="ml-1"
                    @click="copyToken(token)">
                </icon-btn>
              </icon-btns>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </template>

    <!-- 参照先共通辞書編集 -->
    <template #after-form v-if="!isCategory2nd('common')">
      <v-container>
        <v-card outlined>
          <v-card-title style="padding-bottom: 0;">参照先共通辞書</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="4" md="2">
                <hds-id-field
                    :value="defaultDictionary.id"
                    label="デフォルト共通辞書ID"
                    hide-details
                ></hds-id-field>
              </v-col>
              <v-col cols="8" md="4">
                <text-field-like
                    label="デフォルト共通辞書名"
                    :value="defaultDictionary.name"
                    hide-details>
                  <template #default="{value}">
                    <deletable-field :value="value" :deleted="defaultDictionary.isDeleted"/>
                  </template>
                </text-field-like>
              </v-col>
              <v-col cols="12" md="6">
                <v-row align="stretch">
                  <icon-btn
                      v-if="isEditable"
                      tooltip="デフォルト共通辞書を選択"
                      tooltip-short-delay
                      icon="mdi-arrow-right-thick"
                      @click="selectDefaultReferenceDictionary"
                      class="along-with-the-text-field">
                  </icon-btn>
                  <icon-btn
                      v-if="isEditable"
                      type="edit"
                      tooltip="参照先共通辞書を編集"
                      tooltip-short-delay
                      @click="openDictionaryReferenceDialog"
                      class="along-with-the-text-field">
                  </icon-btn>
                  <v-divider vertical class="spacer-between-button-and-combo-box"></v-divider>
                  <model-select
                      v-model="selectedReferenceDictionaryId"
                      :items="referenceDictionaries"
                      label="選択中の共通辞書"
                      :loading="selectedReferenceDictionaryLoading"
                      hide-details
                      loose-menu-width>
                    <template #item="{item, on, attrs}">
                      <v-list-item v-bind="attrs" v-on="on" class="show-label-on-hover dictionary-menu-item">
                        <v-col class="name">
                          <menu-inline>
                            <text-field-like
                                label="名称"
                                :value="item.name"
                                :value-hds-id="item.id">
                              <deletable-field
                                  :value="item.name"
                                  :deleted="!!item.isDeleted"
                                  hide-details/>
                            </text-field-like>
                          </menu-inline>
                        </v-col>
                        <v-col>
                          <menu-inline>
                            <text-field-like
                                label="説明"
                                :value="item.description"
                                placeholder="未設定"
                                multi-line>
                            </text-field-like>
                          </menu-inline>
                        </v-col>
                      </v-list-item>
                    </template>
                  </model-select>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>

      <dictionary-reference-dialog
          v-model="dictionaryReferenceDialog"
          :reference-dictionaries="referenceDictionaries"
          :default-dictionary-id="defaultDictionary.id"
          :dictionary-id="dictionaryId"
          @apply="applyDictionaryReferenceDialog"
      ></dictionary-reference-dialog>
    </template>

    <template #tab-items>
      <v-tab :to="{name: alterRouteName('./datas')}">
        <span>データ構成モデル</span>
        <error-popover
            :errors="errorLevels.dataComponentModel"
            placement="top"
            width="auto"
            hide-title
            dark>
        </error-popover>
      </v-tab>
      <v-tab :to="{name: alterRouteName('./services')}">
        <span>サービス構成モデル</span>
        <error-popover
            :errors="errorLevels.serviceComponentModel"
            placement="top"
            width="auto"
            hide-title
            dark>
        </error-popover>
      </v-tab>
<!--      <v-tab v-if="isCategory2nd('common')">許諾先</v-tab>-->
      <v-tab :to="{name: alterRouteName('./categories')}" v-if="isCategory2nd('common') && isEditable">カテゴリ</v-tab>
    </template>

    <template #after-tabs>
      <router-view
          :dictionary="dictionary"
          :selected-reference-dictionary="selectedReferenceDictionary"
          @dirty="markDirty">
      </router-view>
    </template>
  </form-page-template>
</template>

<script>
import Vue from "vue";
import PathInfoMixin from "@/router/PathInfoMixin";
import {IoableParentPageMixin} from "@/router/IoablePageMixin";
import HdsIdField from "@/components/molecules/HdsIdField.vue";
import OwnerField from "@/components/molecules/OwnerField.vue";
import {mapGetters, mapActions, mapMutations} from "vuex";
import Swal from "sweetalert2";
import query from "@/gql/Dictionary/Query.gql";
import queryReferenceDictionaries from "@/gql/Dictionary/QueryReferenceDictionaries.gql";
import mutationUpdate from "@/gql/Dictionary/Update.gql";
import mutationPublish from "@/gql/Dictionary/Publish.gql";
import FormPageTemplate from "@/components/templates/FormPageTemplate.vue";
import DictionaryReferenceDialog from "@/components/pages/dictionary/Dictionary/DictionaryReferenceDialog.vue";
import natsort from "natsort";
import IdInfo from "@/store/modules/hds/IdInfo";
import DeletableField from "@/components/molecules/DeletableField.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import {safeMeta} from "@/router/Meta";
import gql from "graphql-tag";
import IconBtns from "@/components/molecules/IconBtns";
import IconBtn from "@/components/molecules/IconBtn.vue";
import FileUtils from "@/utils/FileUtils";
import deepEquals from "fast-deep-equal";
import ErrorBuilderMixin from "@/components/pages/dictionary/Dictionary/ErrorBuilderMixin";
import DataSourceMixin from "@/components/pages/dictionary/Dictionary/DataSourceMixin";
import {DICTIONARY_TYPE_NAMES, ERROR_LEVELS} from "@/constants";
import ErrorPopover from "@/components/molecules/ErrorPopover.vue";
import MenuInline from "@/components/atoms/MenuInline.vue";
import ModelSelect from "@/components/molecules/ModelSelect.vue";

const sortFn = natsort();

export default {
  name: 'Dictionary',
  components: {
    ModelSelect,
    MenuInline,
    ErrorPopover,
    IconBtn,
    IconBtns,
    TextFieldLike,
    DeletableField,
    DictionaryReferenceDialog,
    FormPageTemplate,
    HdsIdField,
    OwnerField,
  },
  mixins: [
      PathInfoMixin,
      DataSourceMixin,
      ErrorBuilderMixin,
      IoableParentPageMixin.extend({
        beforeRouteUpdate(to, from, next) {
          next();
          if(to.hash !== from.hash ||
              !deepEquals(to.params, from.params)) {
            this.$nextTick(() => {
              this.doLoad();
            });
          }
        },
      }),
      FileUtils
  ],
  props: {
    dictionaryId: String
  },
  data() {
    return {
      valid: false,
      loadingToken: false,
      issuedToken: undefined,
      selectedReferenceDictionaryId: null,
      selectedReferenceDictionaryLoading: false,
      dictionaryReferenceDialog: false,
      errorLevels: {
        dataComponentModel: [],
        serviceComponentModel: [],
      },
      navigator: window.navigator,
      dictionaryTypeNames: DICTIONARY_TYPE_NAMES,
    };
  },
  created() {
    // データ構成モデルのエラーを監視
    this.$watch(
        () => ([this.dataComponentModels, this.selectedReferenceDictionaryId]),
        ([dataComponentModels]) => {
          const counts = {error: 0, warn: 0, info: 0};
          for (const dcm of dataComponentModels) {
            this.buildDataComponentModelError(dcm).forEach(err => {
              counts[err.level]++;
            });
          }
          const errors = [];
          for (const [level, count] of Object.entries(counts)) {
            if (count > 0) {
              errors.push({
                level, message: `${ERROR_LEVELS[level]} が ${count} 件あります`
              });
            }
          }
          this.errorLevels.dataComponentModel = errors;
        },
        {
          immediate: true
        }
    );

    // サービス構成モデルのエラーを監視
    this.$watch(
        () => ([this.serviceComponentModels, this.selectedReferenceDictionaryId]),
        ([serviceComponentModels]) => {
          const counts = {error: 0, warn: 0, info: 0};
          for (const dcm of serviceComponentModels) {
            this.buildServiceComponentModelError(dcm).forEach(err => {
              counts[err.level]++;
            });
          }
          const errors = [];
          for (const [level, count] of Object.entries(counts)) {
            if (count > 0) {
              errors.push({
                level, message: `${ERROR_LEVELS[level]} が ${count} 件あります`
              });
            }
          }
          this.errorLevels.serviceComponentModel = errors;
        },
        {
          immediate: true
        }
    );
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account',
      entities: 'hds/entities',
      apiClient: 'hds/apiClient',
    }),
    dictionary() {
      return Vue.observable(
          this.entities.dictionary.findOne({id: this.dictionaryId}) || {id: null});
    },
    dictionaryIdInfo() {
      return IdInfo.of(this.dictionaryId);
    },
    referenceDictionaries() {
      if (Array.isArray(this.dictionary.referenceDictionaries)) {
        return Array.from(this.dictionary.referenceDictionaries)
            .sort((a, b) => sortFn(a.name, b.name));
      } else {
        return [];
      }
    },
    defaultDictionary() {
      return this.referenceDictionaries.find(rd => rd.id === this.dictionary.defaultDictionaryId) || {};
    },
    selectedReferenceDictionary() {
      return this.referenceDictionaries.find(rd => rd.id === this.selectedReferenceDictionaryId) || {};
    },
    showExport() {
      return !this.isCategory2nd('external') && this.account?.user?.permissionDictionary;
    },
    showToken() {
      return (this.dictionary.dictionaryType === 'local' || this.dictionary.dictionaryType === 'common') &&
          this.account.owner.id === this.dictionary.ownerId &&
          this.account.owner?.componentOwner &&
          this.account.user.permissionDictionary &&
          (this.dictionary.isPublished || this.dictionaryIdInfo.version >= 2); // 公開バージョンが既にある場合
    },
  },
  methods: {
    ...mapMutations({
      showSnackbar: 'showSnackbar'
    }),
    ...mapActions({
      fetchLoginAccount: 'hcs/fetchLoginAccount',
      gqlQuery: 'hds/gqlQuery',
      gqlQueryAndLoad: 'hds/gqlQueryAndLoad',
      gqlMutate: 'hds/gqlMutate'
    }),

    load() {
      return this.gqlQueryAndLoad({
            clear: true,
            query,
            variables: {
              dictionaryId: this.dictionaryId
            },
            mapping: {
              dictionary: [
                'dictionary',
                'dictionary.referenceDictionaries'
              ],
              dataComponentModel: [
                'dictionary.dataComponentModels',
                'dictionary.referenceDictionaries.dataComponentModels'
              ],
              dataTranslationMap:
                'dictionary.dataTranslationMaps',
              serviceComponentModel: [
                'dictionary.serviceComponentModels',
                'dictionary.referenceDictionaries.serviceComponentModels'
              ],
              processOperation: [
                 'dictionary.serviceComponentModels.processOperations'
              ],
              serviceTranslationMap:
                'dictionary.serviceTranslationMaps',
              category: [
                'dictionary.categories',
                'dictionary.referenceDictionaries.categories'
              ]
            }
          })
          .then(data => {
            const dictionary = data.dictionary;
            if(this.isEditable && dictionary.id !== dictionary.workingCopyDictionaryId) {
              const to = this.$router.resolve({
                params: {
                  dictionaryId: dictionary.workingCopyDictionaryId
                }
              });
              this.$nextTick(() => {
                this.selectedReferenceDictionaryId = null;
                this.$router.replace(to.location);
              });
              return data;
            }
            if(this.selectedReferenceDictionaryId === null) {
              this.selectedReferenceDictionaryId = this.dictionary.defaultDictionaryId;
            }
            return data;
          });
    },
    save() {
      this.entities.dictionary.update(this.dictionary);
      const dictionaryDelta = this.entities.dictionary.getDelta({
        update: [
          'id',
          'name', 'description', 'dictionaryType',
          'isPermittedAllOwners', 'permittedOwnerIds', 'permittedOwnerGroupIds', 'permittedAggregatedOwnerIds',
          'defaultDictionaryId',
          {
            name: 'referenceDictionaryIds',
            source: row => row.referenceDictionaries.map(rd => rd.id)
          }
        ]
      });
      const categoryDelta = this.entities.category.getDelta({
        add: [
          'dictionaryId',
          'name', 'description', 'genre'
        ],
        update: ['id',
          'name', 'description', 'genre'
        ],
        remove: row => row.id
      });
      const dtmDelta = this.entities.dataTranslationMap.getDelta({
        add: [
          'sourceDataComponentModelId', 'parentId', 'dataRelationModelId', 'targetDataComponentModelId', 'dataPropertyTranslationMaps'
        ],
        remove: row => row.id
      });
      const stmDelta = this.entities.serviceTranslationMap.getDelta({
        add: [
          'sourceServiceComponentModelId', 'targetServiceComponentModelId'
        ],
        remove: row => row.id
      });
      return this.gqlMutate({
        mutation: mutationUpdate,
        variables: {
          dictionaryId: this.dictionary.id,
          updateDictionaries: dictionaryDelta.update,
          addCategories: categoryDelta.add,
          updateCategories: categoryDelta.update,
          removeCategoryId: categoryDelta.remove,
          addDataTranslationMaps: dtmDelta.add,
          removeDataTranslationMaps: dtmDelta.remove,
          addServiceTranslationMaps: stmDelta.add,
          removeServiceTranslationMaps: stmDelta.remove
        }
      });
    },

    publish() {
      const validate = async () => {
        const errors = [];

        const emptyDcm = this.entities.dataComponentModel.find({
          dictionaryId: this.dictionaryId,
          dataPropertyDefinitionIds: { $size: 0 },
        });
        if(emptyDcm.length) {
          errors.push(`${emptyDcm.length} 件のデータ構成モデルにデータ項目定義が登録されていません。<br>データ構成モデルにデータ項目定義を登録してください。`);
        }

        const emptyScm = this.entities.serviceComponentModel.find({
          dictionaryId: this.dictionaryId,
          processComponentModelIds: { $size: 0 },
        });
        if(emptyScm.length) {
          errors.push(`${emptyScm.length} 件のサービス構成モデルにプロセス構成モデルが登録されていません。<br>サービス構成モデルにプロセス構成モデルを登録してください。`);
        }

        if(!this.isCategory2nd('common')) {
          const noTranslationMapDcms = this.entities.dataComponentModel.find({dictionaryId: this.dictionaryId})
              .filter(dcm =>
                  this.entities.dataTranslationMap.count({
                    sourceDataComponentModelId: dcm.id,
                    targetDictionaryId: this.dictionary.defaultDictionaryId
                  }) === 0
              );
          if (noTranslationMapDcms.length > 0) {
            errors.push(`デフォルト共通辞書はすべてのデータ構成モデルとマッピングする必要があります。`);
          }

          const noTranslationMapScms = this.entities.serviceComponentModel.find({dictionaryId: this.dictionaryId})
              .filter(scm =>
                  this.entities.serviceTranslationMap.count({
                    sourceServiceComponentModelId: scm.id,
                    targetDictionaryId: this.dictionary.defaultDictionaryId
                  }) === 0
              );
          if (noTranslationMapScms.length > 0) {
            errors.push(`デフォルト共通辞書はすべてのサービス構成モデルとマッピングする必要があります。`);
          }
        }

        if(errors.length) {
          await Swal.fire({
            title: '辞書に不備があります',
            icon: 'warning',
            html: `辞書に以下の不備があるためバージョンを確定できません。
                    <ul><li>${errors.join('</li><li>')}</li></ul>
                    不備を修正して再度お試し下さい。`,
            width: '750px',
            didOpen: _ => {
              Swal.getContent().classList.add('invalid-dictionary');
            }
          });
          throw new Error();
        }
      };

      const confirmSave = () => Swal.fire({
        title: '確認',
        icon: 'info',
        html: `バージョン ${this.dictionaryIdInfo.version} として確定する前に保存する必要があります。<br>確定内容の保存を行いますか？`,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: true,
        confirmButtonText: "はい",
        cancelButtonText: "キャンセル"
      }).then(result => {
        return result.value ? Promise.resolve() : Promise.reject();
      });

      const confirmPublish = () => Swal.fire({
        title: '確認',
        icon: 'warning',
        html: `バージョン ${this.dictionaryIdInfo.version} として確定します。<br>バージョン ${this.dictionaryIdInfo.version} として確定した内容は変更する事ができなくなります。<br>本当にバージョン ${this.dictionaryIdInfo.version} として確定しますか？`,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: true,
        confirmButtonText: "はい",
        cancelButtonText: "キャンセル"
      }).then(result => {
        return result.value ? Promise.resolve() : Promise.reject();
      });

      if (this.dirty) {
        validate()
            .then(_ => {
              return confirmSave();
            })
            .then(_ => {
              return this.doSave();
            })
            .then(_ => {
              return confirmPublish();
            })
            .then(_ => {
              return this.publishImpl();
            })
            .catch(_ => {
              // Cancel
            });
      } else {
        validate()
            .then(_ => {
              return confirmPublish();
            })
            .then(_ => {
              return this.publishImpl();
            })
            .catch(_ => {
              // Cancel
            });
      }
    },
    publishImpl() {
      const loading = this.$loading({
        lock: true,
        text: `バージョン ${this.dictionaryIdInfo.version} として確定処理中...`,
        spinner: 'el-icon-loading',
      });
      return this
          .gqlMutate({
            mutation: mutationPublish,
            variables: {
              publishDictionaryId: this.dictionary.id,
            }
          })
          .then(() => {
            const meta = safeMeta(this.$route);
            this.$router.replace({name: meta.parent});
          }, reason => {
            this.$store.commit({
              type: 'showSnackbar',
              color: 'failed',
              message: `バージョン ${this.dictionaryIdInfo.version} として確定処理に失敗しました`
            });
            console.error(reason);
          })
          .finally(() => {
            loading.close();
          });
    },
    async exportDictionary() {
      const loading = this.$loading({
        lock: true,
        text: `辞書をエクスポートしています...`,
        spinner: 'el-icon-loading',
      });

      try {
        const {data} = await this.apiClient.get('/csv/export', {
          params: {dictionaryId: this.dictionaryId},
          responseType: 'arraybuffer',
        });
        const filename = `${this.dictionary.name}.zip`;
        loading.close();
        this.downloadFile(new Blob([data]), filename);
        this.showSnackbar({
          message: `辞書を ${filename} としてエクスポートしました`
        });
      } catch (e) {
        loading.close();
        console.error(e);
        this.showSnackbar({
          color: 'failed',
          message: `辞書をエクスポートに失敗しました`
        });
      }
    },

    openDictionaryReferenceDialog() {
      this.dictionaryReferenceDialog = true;
    },
    async applyDictionaryReferenceDialog({referenceDictionaryIds, defaultDictionaryId, hasDictionaryVersionUpdate}) {
      if(hasDictionaryVersionUpdate) {
        const {value: confirm} = await Swal.fire({
          title: "確定内容の保存の確認",
          html: "共通辞書参照のアップデートを行う為、辞書への変更の適用を行いますか？",
          icon: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: true,
          confirmButtonText: "はい",
          cancelButtonText: "キャンセル"
        });
        if (!confirm) {
          return;
        }
        await this.applyDictionaryReferenceDialogImpl({referenceDictionaryIds, defaultDictionaryId});
        await this.doSave();
      } else {
        await this.applyDictionaryReferenceDialogImpl({referenceDictionaryIds, defaultDictionaryId});
      }
    },
    applyDictionaryReferenceDialogImpl({referenceDictionaryIds, defaultDictionaryId}) {
      this.selectedReferenceDictionaryLoading = true;
      return this
          .gqlQueryAndLoad({
            query: queryReferenceDictionaries,
            variables: {
              dictionaryIds: referenceDictionaryIds
            },
            mapping: {
              dictionary: 'dictionary*',
              category: 'dictionary.categories*',
              dataComponentModel: 'dictionary.dataComponentModels*',
              serviceComponentModel: 'dictionary.serviceComponentModels*',
            }
          })
          .then(data => {
            this.dictionary.referenceDictionaries = referenceDictionaryIds
                .map(dictionaryId => this.entities.dictionary.findOne({id: dictionaryId}))
                .filter(dictionary => typeof dictionary === 'object' && !!dictionary)
            this.dictionary.defaultDictionaryId = defaultDictionaryId;

            if (!this.referenceDictionaries.find(rd => rd.id === this.selectedReferenceDictionaryId)) {
              this.selectedReferenceDictionaryId = defaultDictionaryId;
            }
            return data;
          })
          .catch(reason => {
            console.error(reason);
          })
          .finally(() => {
            this.selectedReferenceDictionaryLoading = false;
          });
    },
    selectDefaultReferenceDictionary() {
      this.selectedReferenceDictionaryId = this.defaultDictionary.id;
    },
    isTransitionPermitted(destination, route) {
      if(destination === 'edit') {
        const account = this.$store.getters['hcs/account'];
        if (!account.user || !account.owner) {
          return false;
        }
        return account.owner.id === this.dictionary.ownerId && !this.dictionary.isPublished;
      }
    },
    async issueToken() {
      const {value: confirm} = await Swal.fire({
        title: 'トークンの発行',
        icon: 'warning',
        html: "トークンの発行を行います<br>本当によろしいですか？",
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: true,
        confirmButtonText: "はい",
        cancelButtonText: "いいえ"
      });
      if(!confirm) {
        return;
      }

      try {
        this.loadingToken = true;
        const {token} = await this.gqlMutate({
          mutation: gql`
              mutation IssueToken(
                $dictionaryId: ID!
              ) {
                token: issueDictionaryToken(dictionaryId: $dictionaryId)
              }`,
          variables: {
            dictionaryId: this.dictionaryId
          }
        });
        this.issuedToken = token;
      } finally {
        this.loadingToken = false;
      }
    },
    async revokeToken() {
      const {value: confirm} = await Swal.fire({
        title: 'トークンの失効',
        icon: 'warning',
        html: "トークンの失効を行います<br>本当によろしいですか？",
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: true,
        confirmButtonText: "はい",
        cancelButtonText: "いいえ"
      });
      if(!confirm) {
        return;
      }

      try {
        this.loadingToken = true;
        await this.gqlMutate({
          mutation: gql`
              mutation RevokeToken(
                $dictionaryId: ID!
              ) {
                revokeDictionaryToken(dictionaryId: $dictionaryId)
              }`,
          variables: {
            dictionaryId: this.dictionaryId
          }
        });
        this.issuedToken = null;
      } finally {
        this.loadingToken = false;
      }
    },
    async copyToken(token) {
      await this.navigator.clipboard.writeText(token);

      this.showSnackbar({
        message: 'トークンをクリップボードにコピーしました'
      });
    },
    async openCsvUpdateDialog() {
      const file = await this.uploadFile(['application/zip']);
      if(!file) {
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: `辞書をアップデートしています...`,
        spinner: 'el-icon-loading',
      });

      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('dictionaryId', this.dictionaryId);
        await this.apiClient.post('/csv/update', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        });
        loading.close();
        this.showSnackbar({
          message: `辞書をアップデートしました`
        });
        await this.load();
        this.dirty = false;
      } catch (e) {
        loading.close();
        const message = e.response?.data?.message || e.message;
        await Swal.fire({
          title: '辞書データに不備があります',
          icon: 'warning',
          html: `以下のエラーと共に失敗しました。<p class="error-message">${message}</p>`,
          width: '750px',
          didOpen: _ => {
            Swal.getContent().classList.add('import-dictionary-failed');
          }
        })
      }
    },
  },
  watch: {
    dictionary: {
      handler() {
        this.markDirty();
      },
      deep: true,
    },
    selectedReferenceDictionaryId: {
      handler(id) {
        if(this.$route.query.selectedDictionary === id) {
          return;
        }
        this.$router.replace({
          ...this.$route,
          query: {
            selectedDictionary: id ?? undefined
          }
        });
      }
    },
    '$route.query.selectedDictionary': {
      immediate: true,
      handler(id) {
        if(!id || this.selectedReferenceDictionaryId === id) {
          return;
        }
        this.selectedReferenceDictionaryId = id;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.along-with-the-text-field {
  position: relative;
  top: 16px;
}

.spacer-between-button-and-combo-box {
  border-color: transparent;
  width: 10px;
  max-width: 10px;
}
</style>

<style lang="scss">
.invalid-dictionary {
  .swal2-html-container {
    text-align: initial;

    ul {
      list-style-position: outside;
      padding: 0.7rem 0 0.7rem 1.8rem;
    }

    li {
      padding: 0.3rem 0;
    }
  }
}

// タブの警告アイコンの左にマージン
.v-tab > *:nth-child(2) {
  margin-left: 0.2rem;
}

.dictionary-menu-item {
  max-width: 800px;
  min-width: 500px;
}

.col.name {
  max-width: 200px;
}
</style>
